

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Container, Form, Row, Col, InputGroup, Pagination } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa'; // For the search icon
import  * as Constants from '../Constants/Constants'

const Members = () => {
  const [executiveMembers, setExecutiveMembers] = useState([]);
  const [filteredExecutiveMembers, setFilteredExecutiveMembers] = useState([]);
  const [chiefPatrons, setChiefPatrons] = useState([]);
  const [filteredChiefPatrons, setFilteredChiefPatrons] = useState([]);
  const [patrons, setPatrons] = useState([]);
  const [filteredPatrons, setFilteredPatrons] = useState([]);
  const [lifeMembers, setLifeMembers] = useState([]);
  const [filteredLifeMembers, setFilteredLifeMembers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPageExecutive, setCurrentPageExecutive] = useState(1);
  const [currentPageChiefPatron, setCurrentPageChiefPatron] = useState(1);
  const [currentPagePatron, setCurrentPagePatron] = useState(1);
  const [currentPageLifeMember, setCurrentPageLifeMember] = useState(1);
  const recordsPerPage = 10;

  useEffect(() => {
    // Fetch data from API using Axios
    axios.get(`${Constants.BASE_URL}?apitype=101`)
      .then(response => {
        if (response.data.status) {
          // Filter members where isBoardMem is "yes" for Executive Members
          const boardMembers = response.data.mMembersData.filter(member => member.isBoardMem === 'yes');
          setExecutiveMembers(boardMembers);
          setFilteredExecutiveMembers(boardMembers); // Initialize filtered members

          // Filter members where member_type is "Chief Patron"
          const chiefPatronsData = response.data.mMembersData.filter(member => member.member_type === 'Chief Patron');
          setChiefPatrons(chiefPatronsData);
          setFilteredChiefPatrons(chiefPatronsData); // Initialize filtered Chief Patrons

          // Filter members where member_type is "Patron"
          const patronsData = response.data.mMembersData.filter(member => member.member_type === 'Patron');
          setPatrons(patronsData);
          setFilteredPatrons(patronsData); // Initialize filtered Patrons

          // Filter members where member_type is "Life Member"
          const lifeMembersData = response.data.mMembersData.filter(member => member.member_type === 'Life Member');
          setLifeMembers(lifeMembersData);
          setFilteredLifeMembers(lifeMembersData); // Initialize filtered Life Members
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, []);

  // Function to handle search input changes
  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    // Filter for Executive Members
    const filteredExecutive = executiveMembers.filter(member =>
      member.name.toLowerCase().includes(value)
    );
    setFilteredExecutiveMembers(filteredExecutive);
    setCurrentPageExecutive(1); // Reset to first page when searching

    // Filter for Chief Patrons
    const filteredChiefPatron = chiefPatrons.filter(member =>
      member.name.toLowerCase().includes(value)
    );
    setFilteredChiefPatrons(filteredChiefPatron);
    setCurrentPageChiefPatron(1); // Reset to first page when searching

    // Filter for Patrons
    const filteredPatron = patrons.filter(member =>
      member.name.toLowerCase().includes(value)
    );
    setFilteredPatrons(filteredPatron);
    setCurrentPagePatron(1); // Reset to first page when searching

    // Filter for Life Members
    const filteredLifeMember = lifeMembers.filter(member =>
      member.name.toLowerCase().includes(value)
    );
    setFilteredLifeMembers(filteredLifeMember);
    setCurrentPageLifeMember(1); // Reset to first page when searching
  };

  // Pagination Logic for Executive Members
  const indexOfLastRecordExecutive = currentPageExecutive * recordsPerPage;
  const indexOfFirstRecordExecutive = indexOfLastRecordExecutive - recordsPerPage;
  const currentExecutiveRecords = filteredExecutiveMembers.slice(indexOfFirstRecordExecutive, indexOfLastRecordExecutive);
  const totalPagesExecutive = Math.ceil(filteredExecutiveMembers.length / recordsPerPage);

  // Handle page change for Executive Members
  const handlePageChangeExecutive = (page) => {
    setCurrentPageExecutive(page);
  };

  // Pagination Logic for Chief Patrons
  const indexOfLastRecordChiefPatron = currentPageChiefPatron * recordsPerPage;
  const indexOfFirstRecordChiefPatron = indexOfLastRecordChiefPatron - recordsPerPage;
  const currentChiefPatronRecords = filteredChiefPatrons.slice(indexOfFirstRecordChiefPatron, indexOfLastRecordChiefPatron);
  const totalPagesChiefPatron = Math.ceil(filteredChiefPatrons.length / recordsPerPage);

  // Handle page change for Chief Patrons
  const handlePageChangeChiefPatron = (page) => {
    setCurrentPageChiefPatron(page);
  };

  // Pagination Logic for Patrons
  const indexOfLastRecordPatron = currentPagePatron * recordsPerPage;
  const indexOfFirstRecordPatron = indexOfLastRecordPatron - recordsPerPage;
  const currentPatronRecords = filteredPatrons.slice(indexOfFirstRecordPatron, indexOfLastRecordPatron);
  const totalPagesPatron = Math.ceil(filteredPatrons.length / recordsPerPage);

  // Handle page change for Patrons
  const handlePageChangePatron = (page) => {
    setCurrentPagePatron(page);
  };

  // Pagination Logic for Life Members
  const indexOfLastRecordLifeMember = currentPageLifeMember * recordsPerPage;
  const indexOfFirstRecordLifeMember = indexOfLastRecordLifeMember - recordsPerPage;
  const currentLifeMemberRecords = filteredLifeMembers.slice(indexOfFirstRecordLifeMember, indexOfLastRecordLifeMember);
  const totalPagesLifeMember = Math.ceil(filteredLifeMembers.length / recordsPerPage);

  // Handle page change for Life Members
  const handlePageChangeLifeMember = (page) => {
    setCurrentPageLifeMember(page);
  };

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col md={12} className="text-center">
          <h2>Executive Committee Members</h2>
        </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md={6} className="offset-md-6 text-md-end text-sm-start">
          <InputGroup size="sm" style={{ maxWidth: '250px', float: 'right' }}>
            <InputGroup.Text>
              <FaSearch />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search by name..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </InputGroup>
        </Col>
      </Row>

      {loading ? (
        <div className="text-center">Loading...</div>
      ) : (
        <div className="table-responsive">
          <Table bordered hover responsive="sm" className="table-striped">
            <thead className="table-dark">
              <tr>
                <th style={{ backgroundColor: '#124270', color: 'white' }}>Sl. No</th>
                <th style={{ backgroundColor: '#124270', color: 'white' }}>Name</th>
                <th style={{ backgroundColor: '#124270', color: 'white' }}>Position</th>
              </tr>
            </thead>
            <tbody>
              {currentExecutiveRecords.length > 0 ? (
                currentExecutiveRecords.map((member, index) => (
                  <tr key={index}>
                    <td>{index + indexOfFirstRecordExecutive + 1}</td> {/* Serial number */}
                    <td>{member.name}</td> {/* ID */}
                    <td>{member.position_org}</td> {/* Name */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">No members found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}

      {/* Pagination Controls for Executive Members */}
      <Row className="mt-3">
        <Col className="d-flex justify-content-center">
          <Pagination>
            {[...Array(totalPagesExecutive)].map((_, index) => (
              <Pagination.Item
                key={index + 1}
                active={currentPageExecutive === index + 1}
                onClick={() => handlePageChangeExecutive(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </Col>
      </Row>

      {/* Chief Patrons Section */}
      <Row className="mb-3 align-items-center mt-5">
        <Col md={12} className="text-center">
          <h2>Chief Patrons</h2>
        </Col>
      </Row>

      <div className="table-responsive">
        <Table bordered hover responsive="sm" className="table-striped">
          <thead className="table-dark">
            <tr>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>Sl. No</th>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>ID</th>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>Name</th>
            </tr>
          </thead>
          <tbody>
            {currentChiefPatronRecords.length > 0 ? (
              currentChiefPatronRecords.map((member, index) => (
                <tr key={index}>
                  <td>{index + indexOfFirstRecordChiefPatron + 1}</td> {/* Serial number */}
                  <td>{member.ID}</td> {/* ID */}
                  <td>{member.name}</td> {/* Name */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">No Chief Patrons found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination Controls for Chief Patrons */}
      <Row className="mt-3">
        <Col className="d-flex justify-content-center">
          <Pagination>
            {[...Array(totalPagesChiefPatron)].map((_, index) => (
              <Pagination.Item
                key={index + 1}
                active={currentPageChiefPatron === index + 1}
                onClick={() => handlePageChangeChiefPatron(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </Col>
      </Row>

      {/* Patrons Section */}
      <Row className="mb-3 align-items-center mt-5">
        <Col md={12} className="text-center">
          <h2>Patrons</h2>
        </Col>
      </Row>

      <div className="table-responsive">
        <Table bordered hover responsive="sm" className="table-striped">
          <thead className="table-dark">
            <tr>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>Sl. No</th>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>ID</th>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>Name</th>
            </tr>
          </thead>
          <tbody>
            {currentPatronRecords.length > 0 ? (
              currentPatronRecords.map((member, index) => (
                <tr key={index}>
                  <td>{index + indexOfFirstRecordPatron + 1}</td> {/* Serial number */}
                  <td>{member.ID}</td> {/* ID */}
                  <td>{member.name}</td> {/* Name */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">No Patrons found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination Controls for Patrons */}
      <Row className="mt-3">
        <Col className="d-flex justify-content-center">
          <Pagination>
            {[...Array(totalPagesPatron)].map((_, index) => (
              <Pagination.Item
                key={index + 1}
                active={currentPagePatron === index + 1}
                onClick={() => handlePageChangePatron(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </Col>
      </Row>

      {/* Life Members Section */}
      <Row className="mb-3 align-items-center mt-5">
        <Col md={12} className="text-center">
          <h2>Life Members</h2>
        </Col>
      </Row>

      <div className="table-responsive">
        <Table bordered hover responsive="sm" className="table-striped">
          <thead className="table-dark">
            <tr>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>Sl. No</th>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>ID</th>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>Name</th>
            </tr>
          </thead>
          <tbody>
            {currentLifeMemberRecords.length > 0 ? (
              currentLifeMemberRecords.map((member, index) => (
                <tr key={index}>
                  <td>{index + indexOfFirstRecordLifeMember + 1}</td> {/* Serial number */}
                  <td>{member.ID}</td> {/* ID */}
                  <td>{member.name}</td> {/* Name */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">No Life Members found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination Controls for Life Members */}
      <Row className="mt-3">
        <Col className="d-flex justify-content-center">
          <Pagination>
            {[...Array(totalPagesLifeMember)].map((_, index) => (
              <Pagination.Item
                key={index + 1}
                active={currentPageLifeMember === index + 1}
                onClick={() => handlePageChangeLifeMember(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </Col>
      </Row>
    </Container>
  );
};

export default Members;

